import React, {useState, useRef} from 'react';
import {usePopper} from 'react-popper';
import useClickOutside from 'helpers/useClickOutside';
import './style.scss';

const TableTdDropdown = ({activeValue, options, onSelect}) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const containerRef = useRef();

    const toggle = () => {
        setDropdownOpen(prevState => !prevState);
    };

    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const [arrowElement, setArrowElement] = useState(null);

    const {styles, attributes} = usePopper(referenceElement, popperElement, {
        modifiers: [{name: 'arrow', options: {element: arrowElement}}],
    });

    const handlePortalSelect = (id, name) => {
        onSelect(id, name);
        setDropdownOpen(false);
    };

    useClickOutside(containerRef, () => {
        if(containerRef) {
            dropdownOpen && setDropdownOpen(false);
        }
    });

    return (
        <div ref={containerRef}>
            <button className="btn btn-secondary dropdown-toggle table-td-dropdown__toggle" onClick={toggle}
                    type="button" ref={setReferenceElement}>
                {activeValue}
            </button>

            {dropdownOpen && (
                <div
                    className="table-td-dropdown__portal-toggle"
                    ref={setPopperElement}
                    style={{
                        ...styles.popper,
                        // width: '158px',
                        backgroundColor: '#ffffff',
                        border: '1px solid #d8dbe0',
                        borderRadius: '.25rem',
                        color: '#3c4b64',
                        zIndex: 1000,
                    }}
                    {...attributes.popper}
                >
                    {options.map(item => (
                        <div
                            className="dropdown-item table-td-dropdown__item"
                            onClick={() => handlePortalSelect(item.id, item.name)}
                        >
                            {item.name}
                        </div>
                    ))}
                    <div ref={setArrowElement} style={styles.arrow}/>
                </div>
            )}
        </div>
    );
};

export default TableTdDropdown;
